import { Link, useLocation } from "react-router-dom";
import { Instagram } from "lucide-react";
import { NAV_LINKS, scrollToId } from "@/data/content";

export default function Footer() {
  const { pathname } = useLocation();
  const isHome = pathname === "/";

  const go = (e, id) => {
    e.preventDefault();
    scrollToId(id);
  };

  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-deepnavy py-16 md:py-20">
      <div className="mx-auto max-w-7xl px-5 md:px-10">
        <div className="grid gap-12 md:grid-cols-[1.5fr_1fr_1fr]">
          <div>
            <span className="font-display text-3xl md:text-4xl font-bold tracking-[0.15em] text-cream">
              SHIYADN
            </span>
            <span className="mt-1 block font-head text-sm font-semibold text-copper">
              شيادن الأصول العقارية
            </span>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-cream/50">
              علامة عقارية سعودية متخصصة في التسويق العقاري والوساطة العقارية
              والتأجير للغير.
            </p>
            <a
              href="mailto:Owner@Shiyadn.com"
              data-testid="footer-email-link"
              dir="ltr"
              className="mt-4 block w-fit text-sm text-copper transition-colors duration-300 hover:text-cream"
            >
              Owner@Shiyadn.com
            </a>
            <a
              href="https://www.tiktok.com/@Shiyadn"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-tiktok-link"
              dir="ltr"
              className="mt-2 flex w-fit items-center gap-2 text-sm text-cream/50 transition-colors duration-300 hover:text-copper"
            >
              <svg viewBox="0 0 24 24" fill="currentColor" className="h-4 w-4" aria-hidden="true">
                <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z" />
              </svg>
              @Shiyadn
            </a>
            <a
              href="https://www.instagram.com/Shiyadn0"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram-link"
              dir="ltr"
              className="mt-2 flex w-fit items-center gap-2 text-sm text-cream/50 transition-colors duration-300 hover:text-copper"
            >
              <Instagram className="h-4 w-4" />
              @Shiyadn0
            </a>
            <div className="mt-6 space-y-1 text-xs text-cream/35" data-testid="footer-legal-numbers">
              <p>سجل تجاري: 7055236751</p>
              <p>رقم ترخيص فال: يُضاف قريبًا</p>
            </div>
          </div>

          <nav data-testid="footer-quick-links">
            <span className="font-head text-sm font-bold text-cream/80">روابط سريعة</span>
            <ul className="mt-5 space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.id}>
                  {isHome ? (
                    <a
                      href={l.id}
                      onClick={(e) => go(e, l.id)}
                      data-testid={`footer-link-${l.id.slice(1)}`}
                      className="text-sm text-cream/50 transition-colors duration-300 hover:text-copper"
                    >
                      {l.label}
                    </a>
                  ) : (
                    <Link
                      to={`/${l.id}`}
                      data-testid={`footer-link-${l.id.slice(1)}`}
                      className="text-sm text-cream/50 transition-colors duration-300 hover:text-copper"
                    >
                      {l.label}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <span className="font-head text-sm font-bold text-cream/80">الأنظمة</span>
            <ul className="mt-5 space-y-3">
              <li>
                <Link to="/privacy" data-testid="footer-privacy-link" className="text-sm text-cream/50 transition-colors duration-300 hover:text-copper">
                  سياسة الخصوصية
                </Link>
              </li>
              <li>
                <Link to="/terms" data-testid="footer-terms-link" className="text-sm text-cream/50 transition-colors duration-300 hover:text-copper">
                  الشروط والأحكام
                </Link>
              </li>
              <li>
                <Link to="/admin" data-testid="footer-admin-link" className="text-sm text-cream/50 transition-colors duration-300 hover:text-copper">
                  دخول المشرف
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-wrap items-center justify-between gap-4 border-t border-white/10 pt-8">
          <p className="text-xs text-cream/40">
            © 2026 شيادن الأصول العقارية — جميع الحقوق محفوظة
          </p>
          <span className="font-display text-xs tracking-[0.35em] text-cream/30">
            SHIYADN REAL ESTATE ASSETS
          </span>
        </div>
      </div>
    </footer>
  );
}
